export interface Blog {
  _id: string;
  title: string;
  excerpt: string;
  description: string;
  content: string;
  category: string;
  author: string;
  readTime: string;
  featured: boolean;
  tags: string[];
  image: string;
  slug: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string[];
  createdAt: string;
  updatedAt: string;
}

// Mock blog data - no backend dependency
const mockBlogs: Blog[] = [
  {
    _id: "1",
    title: "Advanced FRP Solutions for Chemical Industry",
    excerpt: "Discover how FRP technology is revolutionizing chemical processing with superior corrosion resistance.",
    description: "Comprehensive guide to FRP applications in chemical industries",
    content: "FRP (Fiber Reinforced Plastic) has become the material of choice for chemical processing equipment due to its exceptional corrosion resistance...",
    category: "Technology",
    author: "SS Plastic Team",
    readTime: "5 min",
    featured: true,
    tags: ["FRP", "Chemical", "Corrosion"],
    image: "/blog1.webp",
    slug: "advanced-frp-solutions-chemical-industry",
    seoTitle: "Advanced FRP Solutions for Chemical Industry | SS Plastic",
    seoDescription: "Discover how FRP technology is revolutionizing chemical processing with superior corrosion resistance.",
    seoKeywords: ["FRP", "chemical industry", "corrosion resistance"],
    createdAt: "2024-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z",
  },
  {
    _id: "2",
    title: "Maintenance Guide for FRP Storage Tanks",
    excerpt: "Essential tips and best practices for maintaining FRP storage tanks to ensure longevity and safety.",
    description: "Complete maintenance guide for FRP storage tanks",
    content: "Proper maintenance of FRP storage tanks is crucial for ensuring their longevity and operational safety...",
    category: "Maintenance",
    author: "Technical Team",
    readTime: "7 min",
    featured: false,
    tags: ["FRP", "Maintenance", "Storage Tanks"],
    image: "/blog2.webp",
    slug: "maintenance-guide-frp-storage-tanks",
    seoTitle: "Maintenance Guide for FRP Storage Tanks | SS Plastic",
    seoDescription: "Essential tips and best practices for maintaining FRP storage tanks to ensure longevity and safety.",
    seoKeywords: ["FRP maintenance", "storage tanks", "industrial maintenance"],
    createdAt: "2024-01-10T14:30:00Z",
    updatedAt: "2024-01-10T14:30:00Z",
  }
];

// Local data functions - no backend dependency
export async function fetchBlogs(
  category?: string,
  featured?: boolean,
  limit?: number,
  excludeSlug?: string
): Promise<Blog[]> {
  await new Promise(resolve => setTimeout(resolve, 200));
  
  let filteredBlogs = [...mockBlogs];
  
  if (category && category !== 'All') {
    filteredBlogs = filteredBlogs.filter(blog => blog.category === category);
  }
  
  if (featured !== undefined) {
    filteredBlogs = filteredBlogs.filter(blog => blog.featured === featured);
  }
  
  if (excludeSlug) {
    filteredBlogs = filteredBlogs.filter(blog => blog.slug !== excludeSlug);
  }
  
  if (limit) {
    filteredBlogs = filteredBlogs.slice(0, limit);
  }
  
  return filteredBlogs;
}

export async function fetchBlogById(id: string): Promise<Blog> {
  await new Promise(resolve => setTimeout(resolve, 200));
  
  const blog = mockBlogs.find(b => b._id === id);
  if (!blog) {
    throw new Error("Blog not found");
  }
  
  return blog;
}

export async function fetchBlogBySlug(slug: string): Promise<Blog> {
  await new Promise(resolve => setTimeout(resolve, 200));
  
  const blog = mockBlogs.find(b => b.slug === slug);
  if (!blog) {
    throw new Error("Blog not found");
  }
  
  return blog;
} 